export default __webpack_public_path__ + "static/media/milestone.21f3382e.svg";